export const ANONYMOUS = 'anonymous';

export const PERSONALIZED = 'personalized';
